import { Router } from "@angular/router";

export const toollist =  [
    {
        "Type": "Button",
        "Label": "Nouvelle action",
        "Color": "accent",
        "Icon": "add",
        "Method": "createNewAction",
    },
    {
        "Type": "Button",
        "Label": "Liste",
        "Color": "primary",
        "Icon": "list",
        "Method": "setModList",
    },
    {
        "Type": "Button",
        "Label": "Kanban",
        "Color": "primary",
        "Icon": "task",
        "Method": "setModKanban",
    },
    {
        "Type": "Button",
        "Label": "Indicateur",
        "Color": "primary",
        "Icon": "fact_checked",
        "Method": "setModIndic",
        "Condition": "inIndicAvailable"
    },
    {
        "Type": "Button",
        "Label": "Mode d'emploi",
        "Color": "danger",
        "Icon": "help",
        "Method": "toggleManual"
    },
    {
        //"Type": "Link",
        "Type": "Button",
        "Label": "Retour",
        "Color": "disabled",
        "Icon": "arrow_back_ios",
        //"Link": ['/','rm','objectifs'],
        "Method": "goBack"
    }
]